import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { TrackLinkDirective } from '@analytics/events';
import { DefaultComponentModule } from '@innogy/core/modules/components';

@Component({
  selector: 'wl-commodity-offer-view-tariffs',
  templateUrl: './commodity-offer-view-tariffs.component.html',
  standalone: true,
  imports: [AutomationIdDirective, TrackLinkDirective, DefaultComponentModule],
})
export class CommodityOfferViewTariffsComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tariffModalDescriptionLabel?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() tariffModalLinkTextLabel?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() centerAlignedTariffLink = false;
  @Output() viewTariffs = new EventEmitter<void>();
}
